import { render, staticRenderFns } from "./SearchDevelopmentsForm.vue?vue&type=template&id=5895a412&scoped=true"
import script from "./SearchDevelopmentsForm.vue?vue&type=script&lang=js"
export * from "./SearchDevelopmentsForm.vue?vue&type=script&lang=js"
import style0 from "./SearchDevelopmentsForm.vue?vue&type=style&index=0&id=5895a412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5895a412",
  null
  
)

export default component.exports